import { useTranslation } from 'react-i18next'
import { useWeb3React } from '@web3-react/core'
import {
  StyledLabelWrapper,
  StyledIcon,
  StyledLabel,
  StyledIconExpand,
} from '../styled'
import IconArrowExpand from '~/assets/images/arrow-expand.svg'
import IconMenuSettings from '~/assets/images/menu-settings.svg'
import styled from 'styled-components'

const AuthorizationManage: React.FC = () => {
  const { t } = useTranslation()

  const { account } = useWeb3React()
  const allowanceManagingUrl = `https://app.scamsniffer.io/permits/${account}`

  return (
    <a href={allowanceManagingUrl} target="_blank">
      <Container>
        <StyledLabelWrapper>
          <StyledIcon src={IconMenuSettings} />
          <StyledLabel>{t('authorized_tokens')}</StyledLabel>
          <StyledIconExpand src={IconArrowExpand} />
        </StyledLabelWrapper>
      </Container>
    </a>
  )
}

export default AuthorizationManage

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  margin-top: 30px;
  cursor: pointer;
`
